import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  validateNumberOnly(event) {
    event.target.value = event.target.value.replace(/\D/g, '')
  }
}
